import React from "react";
import { connect } from "react-redux";
import { createEditAccidenteData } from "../Planes/actions";
import SelectField from "../../Shared/fields/SelectField";

const tipoAccidente = [
  { id: "01", name: "Asalto/Acoso" },
  { id: "02", name: "Ataque animal" },
  { id: "03", name: "Atrapamiento" },
  { id: "04", name: "Atropello" },
  { id: "05", name: "Caída a distino nivel" },
  { id: "06", name: "Caída al mismo nivel" },
  { id: "07", name: "Colisión de Vehículos" },
  { id: "08", name: "Exposición a agentes" },
  { id: "09", name: "Golpe con objeto" },
  { id: "10", name: "Falso movimiento" },
];
const medioTransporte = [
  { id: "01", name: "Bicicleta" },
  { id: "02", name: "Bus/Microbus/Trolebus" },
  { id: "03", name: "Caminata" },
  { id: "04", name: "Metro/Tren" },
  { id: "05", name: "Motocicleta" },
  { id: "06", name: "Taxi/Colectivo" },
  { id: "07", name: "Automóvil" },
  { id: "08", name: "Monopatín (scooter)" },
];

class SiniestroItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tipoAccidente: this.props.data.tipoAccidente ? this.props.data.tipoAccidente : null,
      medioTransporte: this.props.data.medioTransporte ? this.props.data.medioTransporte : null,
    };
  }

  handleChange = (e) => {
    switch (e.element.id) {
      case "medio-transporte":
        this.setState({ medioTransporte: e.value });
        break;
      case "tipo-accidente":
        this.setState({ tipoAccidente: e.value });
        break;
      default:
    }
  }

  render() {
    return (
      <section id="content-etapa">
        <div className="container-fluid">
          <div className="row PM-plan-borde-spacing">
            <div className="col-md-12 text-left PM-plan-contador-tareas PM-home-item-plan">
              <div className="col-md-12 pt-10">
                <SelectField
                  id="tipo-accidente"
                  label="Tipo de Accidente"
                  value={this.state.tipoAccidente}
                  onChange={this.handleChange}
                  items={tipoAccidente}
                  displayExpr="name"
                  valueExpr="name"
                />
                <SelectField
                  id="medio-transporte"
                  label="Medio de Transporte"
                  value={this.state.medioTransporte}
                  onChange={this.handleChange}
                  items={medioTransporte}
                  displayExpr="name"
                  valueExpr="name"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="btn-box row" style={{ marginTop: 10 }}>
          <div className="col-md-8"></div>
          <div className="col-md-4 text-right">
          <button className="btn PM-dx-button-plan PM-dx-button-plan-100" onClick={() => this.props.dispatch(createEditAccidenteData(this.props.data.idsiniestro, this.props.data.idcentro, this.props.data.idempresa, this.props.data.ruttrabajador, this.props.data.nombreTrabajador, this.props.data.fpresentacion, this.props.data.fsiniestro, this.props.data.existeBD, this.state.medioTransporte, this.state.tipoAccidente))}>Actualizar</button>
            {/* <button className="btn PM-dx-button-plan PM-dx-button-plan-100" disabled>Actualizar</button> */}
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SiniestroItem);
